import { render, staticRenderFns } from "./TicketOfferTypeIconVariant1.vue?vue&type=template&id=06a825b6&scoped=true&"
import script from "./TicketOfferTypeIconVariant1.vue?vue&type=script&lang=js&"
export * from "./TicketOfferTypeIconVariant1.vue?vue&type=script&lang=js&"
import style0 from "./TicketOfferTypeIconVariant1.vue?vue&type=style&index=0&id=06a825b6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06a825b6",
  null
  
)

export default component.exports